import React from "react";
import {utils_tool, component_tool, framework_tool} from "@/tool";

let {WizModal} = component_tool;
let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'scheduleManagement';
let ref;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "课件名称",
    name: "searchName",
    searchItem: {}
  },
  {
    title: "课件名称",
    name: "name",
    tableItem: {
      width: 250,
    }
  },
  {
    title: "编号",
    name: "code",
    searchItem: {},
    tableItem: {
      width: 200,
    },
    formItem: {}
  },
  {
    title: "文件格式",
    name: "type",
    dataIndex: "type",
    tableItem: {
      width: 100,
    },
    dict: [
      {code: 0, codeName: "视频"},
      {code: 1, codeName: "语音"},
      {code: 2, codeName: "H5"},
      {code: 3, codeName: "PPT"},
      {code: 4, codeName: "PDF"},
      {code: 5, codeName: "SCORM"},
      {code: 6, codeName: "图片"}
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "select"
    }
  },
  {
    title: "时长（分）",
    name: "duration",
    tableItem: {
      width: 100,
    },
    formItem: {
      type: 'number'
    }
  },
  {
    title: "介绍",
    name: "intro",
    formItem: {
      type: 'textarea',
      placeholder: '介绍最多输入100个字符',
      maxlength: 100,
    },
  },
  {
    title: "状态",
    name: "status",
    dict: [
      {code: 0, codeName: "草稿"},
      {code: 1, codeName: "发布"},
      {code: 2, codeName: "关闭"}
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "radio"
    }
  },
  {
    title: "支持平台",
    name: "supports",
    dict: [
      {code: 0, codeName: "PC"},
      {code: 1, codeName: "APP"}
    ],
    searchItem: {
      type: "select"
    }
  },
  {
    title: "支持平台",
    name: "supportsName",
    tableItem: {
      width: 150,
    },
    formItem: {}
  },
  {
    title: "添加水印",
    name: "waterMark",
    dict: [
      {code: 0, codeName: "是"},
      {code: 1, codeName: "否"}
    ],
    searchItem: {
      type: "select"
    },
    tableItem: {
      width: 100,
    }

  },
  {
    title: "课件方向",
    name: "orientation",
    dict: [
      {code: 0, codeName: "竖屏"},
      {code: 1, codeName: "横屏"},
      {code: 2, codeName: "都支持"}
    ],
    formItem: {
      type: "radio",
    }
  },
  {
    title: "支持下载",
    name: "downType",
    dict: [
      {code: 0, codeName: "PC下载"},
      {code: 1, codeName: "APP离线"}
    ],
    formItem: {
      type: "checkbox",
    }
  },
  {
    title: "是否公开",
    name: "publicSchedule",
    dict: [{code: 1, codeName: '公开'}],
    formItem: {
      type: 'checkbox',
    },
  },
  {
    title: "状态",
    name: "statusName",
    dataIndex: "statusName",
    tableItem: {
    },
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort: ['group', 'delete', 'batchClose', 'export'],
        buttons: [
          {
            key: 'group',
            type: 'group',
            params: {icon: 'down', children: '新增课件', type: 'primary'},
            options: [
              {
                key: 'addVideo',
                custom: true,
                params: {children: '视频'},
                customOnClick: {
                  key: 'jumpPage',
                  params: {
                    key: 'push',
                    pathname: '/program/scheduleList/scheduleDetailAdd',
                    record: {code: 0}
                  },
                }
              },
              {
                key: 'addVoice',
                custom: true,
                params: {children: '语音'},
                customOnClick: {
                  key: 'jumpPage',
                  params: {
                    key: 'push',
                    pathname: '/program/scheduleList/scheduleDetailAdd',
                    record: {code: 1}
                  },
                }
              },
              {
                key: 'addH5',
                custom: true,
                params: {children: 'H5'},
                customOnClick: {
                  key: 'jumpPage',
                  params: {
                    key: 'push',
                    pathname: '/program/scheduleList/scheduleDetailAdd',
                    record: {code: 2}
                  },
                }
              },
              {
                key: 'addPPT',
                custom: true,
                params: {children: 'PPT'},
                customOnClick: {
                  key: 'jumpPage',
                  params: {
                    key: 'push',
                    pathname: '/program/scheduleList/scheduleDetailAdd',
                    record: {code: 3}
                  },
                }
              },
              {
                key: 'addPDF',
                custom: true,
                params: {children: 'PDF'},
                customOnClick: {
                  key: 'jumpPage',
                  params: {
                    key: 'push',
                    pathname: '/program/scheduleList/scheduleDetailAdd',
                    record: {code: 4}
                  },
                }
              },
              {
                key: 'addScorm',
                custom: true,
                params: {children: 'SCORM'},
                customOnClick: {
                  key: 'jumpPage',
                  params: {
                    key: 'push',
                    pathname: '/program/scheduleList/scheduleDetailAdd',
                    record: {code: 5}
                  }
                }
              }
            ]
          },
          {
            key: "batchClose",
            custom: true,
            needSelect: true,
            params: {icon: "into", children: "批量关闭", type: "info"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateScheduleStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                // const content = `您确定要批量关闭这${
                //   $$.isArray(rows) ? rows.length : ""
                // }条课件？`;
                const content = '你确定要关闭选中的课件吗？'
                let ids = [];
                rows.forEach(e => {
                  if (e['rowKey']) {
                    ids.push(e['rowKey']);
                  }
                });
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      idList: ids,
                      status: 2
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = 0;
              if (rows && rows instanceof Array && rows.length>0){
                rows.forEach(item => {
                  let {status} =item;
                  if (status !=null && status===2){
                    disabled=1;
                  }
                })
              }else {
                disabled = 1;
              }
              return { disabled: disabled }
            }
          },
          {
            key: "delete",
            custom: true,
            needSelect: true,
            params: {icon: "delete", children: "删除", type: "danger"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                // const content = `删除后数据不可恢复，您确定要删除这${
                //   $$.isArray(rows) ? rows.length : ""
                // }条课件吗？`;
                const content = '删除后数据不可恢复，您确定要删除选中的课件吗？'
                let ids = [];
                rows.forEach(e => {
                  if (e['rowKey']){
                    ids.push(e['rowKey']);
                  }
                });
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = 0;
              if (rows && rows instanceof Array && rows.length>0){
                rows.forEach(item => {
                  let {status} =item;
                  if (status !=null && status!=0){
                    disabled=1;
                  }
                })
              }else {
                disabled = 1;
              }
              return { disabled: disabled }
            }
          },
          {
            key: "export",
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "Modal",
            children: "Bla bla123 .."
          }
        }
      },
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false,
      },
      rowOperateSort: ['update', 'releaseOrClose'],
      rowOperateView: [
        {
          key: "releaseOrClose",
          custom: true,
          params: {children: "发布"},
          textFormat: {
            recordKey: 'status',
            dirt: {0: '发布', 2: '发布', 1: '关闭'}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateScheduleStatus",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['status'] === 0 || record['status'] === 2 ? "发布" : "关闭"
              }该课件吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    status: record['status'] === 0 || record['status'] === 2 ? 1 : 2,
                    idList: [record['id']]
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: {children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/program/scheduleList/scheduleDetailUpd"
            }
          },
          recordChangeParams: ({ record, rows }) => {
            return { disabled: record.type===6 }
          }
        }
      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true,
        look: false

      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@getListByPage`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  updateScheduleStatus: {
    path: `${componentName}/updateScheduleStatus`,
    payload: {
      key: `${componentName}@updateScheduleStatus`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
